import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SearchCardProps } from './SearchCardModel';
import { 
  SearchCardContainer, 
  CardContent, 
  CardTitle, 
  CardExcerpt, 
  CardLink 
} from './SearchCard.styled';

const SearchCard: React.FC<SearchCardProps> = ({ result, className }) => {
  const { t } = useTranslation();
  return (
    <SearchCardContainer className={className}>

      <CardContent>
        <CardTitle>{result.title}</CardTitle>
        <CardExcerpt>{result.content}</CardExcerpt>
        <CardLink as={Link} to={result.url}>
          {t('components.search.viewMore')}
        </CardLink>
      </CardContent>
    </SearchCardContainer>
  );
};

export default SearchCard;
